import videojs from 'video.js';

export default class ControlsSpacer extends videojs.getComponent('Component') {
  constructor(player, options = {}) {
    super(player, options);
    this.addClass('vjs-spacer');
  }
}
